import { defineComponent as _defineComponent } from 'vue'
import {
	withDefaults,
	ref,
	Ref,
	watch,
	computed,
	ComputedRef,
} from "vue";
import store from "@/vue/planning/store/store";

// components
import Fees from "@/vue/planning/components/summary/fees.vue";
import Accommodations from "@/vue/planning/components/summary/accommodations.vue";
import BorderHorizontal from "@/vue/common/borderHorizontal.vue";
import Options from "@/vue/planning/components/summary/options.vue";
import BottomButtons from "@/vue/planning/components/summary/bottomButtons.vue";
import Total from "@/vue/planning/components/summary/total.vue";
import StickySummary from "@/vue/planning/components/stickySummary.vue";

// computed
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes";

interface Props {
	transition: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'summary',
  props: {
    transition: { default: "height 150ms ease-in-out" }
  },
  setup(__props: any) {

const props = __props as { transition: string }



// refs
const summary = ref();
const isCollapsed: Ref<boolean> = ref(true);
const isAnimating: Ref<boolean> = ref(false);

// computed
const stepNum: ComputedRef<string> = computed(() => {
	if (
		availableTransportPackCodes.value.length > 0 &&
		store.state.screenType === "desktop"
	)
		return "4. ";
	return "3. ";
});
const anySelectedVariant: ComputedRef<any> = computed(() => {
	if (
		!store.getters.selectedPrestations ||
		store.getters.selectedPrestations.length === 0
	)
		return;
	return store.getters.selectedPrestations[0].prestation;
});

// TODO probably makes more sense to use a third-party package or a builtin for the collapse-expand animation

// methods
const collapse = () => {
	if (isAnimating.value) return;
	isAnimating.value = true;
	setTimeout(() => {
		isAnimating.value = false;
	}, 150);

	const sectionHeight = summary.value.scrollHeight;

	summary.value.style.overflow = "hidden";

	const elementTransition = summary.value.style.transition;
	summary.value.style.transition = "";

	requestAnimationFrame(() => {
		summary.value.style.height = sectionHeight + "px";
		summary.value.style.transition = elementTransition;

		requestAnimationFrame(() => {
			summary.value.style.height = 0 + "px";
		});
	});

	isCollapsed.value = true;
};

const expand = () => {
	if (isAnimating.value) return;
	isAnimating.value = true;
	setTimeout(() => {
		isAnimating.value = false;
	}, 150);

	summary.value.style.overflow = "hidden";
	setTimeout(() => {
		summary.value.style.overflow = "visible";
	}, 150);

	const sectionHeight = summary.value.scrollHeight;

	summary.value.style.height = sectionHeight + "px";

	const transitionendListener = () => {
		summary.value.removeEventListener("transitionend", transitionendListener);
		summary.value.style.height = null;
	};
	summary.value.addEventListener("transitionend", transitionendListener);

	isCollapsed.value = false;
};

// watch
watch(
	() => store.getters.totalSelectedHebergements,
	(newValue, oldValue) => {
		if (newValue > 0 && oldValue === 0) {
			expand();
		} else if (newValue === 0 && oldValue > 0) {
			collapse();
		}
	}
);

return { __sfc: true,props, summary, isCollapsed, isAnimating, stepNum, anySelectedVariant, collapse, expand, store, Fees, Accommodations, BorderHorizontal, Options, BottomButtons, Total, StickySummary }
}

})